import React from 'react';

// Monto máximo de las transferencias que ve un operador (ver limiteDeMonto en
// functions). `valor` son solo dígitos, como string. Vacío = ve todas, o las del
// límite de la cuenta (`limiteCuenta`) si tiene uno.

export const pesos = (monto) => `$${Number(monto).toLocaleString('es-AR')}`;

export const limiteDe = (valor) => (Number(valor) > 0 ? Number(valor) : null);

function CampoLimiteMonto({ id, valor, onChange, disabled, limiteCuenta }) {
    return (
        <div className="operator-form-group">
            <label className="operator-form-label" htmlFor={id}>
                Monto máximo de transferencias que ve
            </label>
            <div className="campo-monto">
                <span className="campo-monto__signo">$</span>
                <input
                    id={id}
                    type="text"
                    inputMode="numeric"
                    className="operator-form-input campo-monto__input"
                    placeholder={limiteCuenta ? `${Number(limiteCuenta).toLocaleString('es-AR')} (límite de la cuenta)` : 'Sin límite'}
                    value={valor ? Number(valor).toLocaleString('es-AR') : ''}
                    onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 9))}
                    disabled={disabled}
                />
            </div>
            <p className="role-description">
                {limiteDe(valor)
                    ? `Solo va a ver las transferencias de hasta ${pesos(valor)}. Las más grandes no le aparecen.`
                    : limiteCuenta
                        ? `Dejalo vacío para que use el límite de la cuenta: las de hasta ${pesos(limiteCuenta)}.`
                        : 'Dejalo vacío para que vea todas las transferencias.'}
            </p>
        </div>
    );
}

export default CampoLimiteMonto;
